export default __webpack_public_path__ + "static/wfh-84e819eaad16cc393438a547c2fd585b.jpg";